module.exports = __webpack_public_path__ + "assets/img/address_icon.05fd77d7.png";